import React, { Component } from 'react';
import { PropTypes, SlideProps } from '@material-ui/core';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogProps,
    DialogTitle,
    Slide
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { ConfirmDialogProps } from '../../js/types';

/**
 * @description 通知查看詳細視窗
 * @param {boolean} dividers 顯示頂部和底部分隔線
 * @param {boolean} fullWidth 設置 false 為禁用 maxWidth
 * @param {string} maxWidth 確定 dialog 的最大寬度 ex : 'lg'|'md'|'sm'|'xl'|'xs'|false
 * @param {string} scroll 決定卷軸在 modal 內或外 'paper'|'body'
 * @param {function} closeClick 通知查看詳細視窗關閉 事件
 * @param {function} openDialog 通知查看詳細視窗開啟 事件
 * @param {obj} dialogInfo 決定通知視窗內容 
 * ex: dialogInfo: {message: "", data: ""}
 * @param {string} color 主顏色
 */

type SnackbarDialogTSProps = {
    openDialog: boolean,
    dialogInfo: any,
    // {
    //     message: string,
    //     data: { [key: string]: string[] } | null,
    //     [key: string]: any
    // },
    maxWidth: DialogProps['maxWidth'],
    closeClick: () => void,
    color: PropTypes.Color
}


export function SnackbarDialogTS(props: SnackbarDialogTSProps) {
    const { openDialog, dialogInfo } = props;

    /**@description 最終呈現錯誤內容Array */
    let errorMessageArr: string[] = [];

    let errorArr: any[] = [];
    let errorObj: SnackbarDialogTSProps['dialogInfo']['data'] = {};
    let msg_title = "";
    if (openDialog && !!dialogInfo.data) {
        if (typeof dialogInfo.data === 'object') { // API內部錯誤
            if ('ClassName' in dialogInfo.data) {
                errorArr.push(dialogInfo.data.ClassName);
                errorArr.push(dialogInfo.data.StackTraceString);
                errorArr.push(JSON.stringify(dialogInfo.data.Errors));
            }
            // 錯誤訊息obj
            else {
                errorObj = dialogInfo.data
            }

            // API內部錯誤 處理
            if (errorArr.length > 0) {
                for (let index in errorArr) {
                    let dataKeyName = ['ClassName', 'StackTraceString', 'Errors']
                    let msg = "";
                    let msg_arr = dialogInfo.data[dataKeyName[index]];
                    console.log('index', index, 'msg_arr', !!msg_arr,);

                    if (!!msg_arr) {
                        console.log('name', msg_arr.constructor.name.toLowerCase());

                        if (msg_arr.constructor.name.toLowerCase() === "array") {
                            let num = parseInt(index.substring(index.indexOf("[") + 1, index.indexOf("]")))
                            for (let i in msg_arr) {
                                if (isNaN(num)) {
                                    msg += JSON.stringify(msg_arr[i]);
                                } else {
                                    msg_title = `第${(' [' + (num + 1) + '] ')}列 : `;
                                    msg += JSON.stringify(msg_arr[i]) + " ";
                                }
                            }
                            errorMessageArr.push(msg_title + msg)
                        } else if (msg_arr.constructor.name.toLowerCase() === "object") {
                            for (let i in msg_arr) {
                                msg_title = `第${(' [' + (parseInt(index) + 1) + '] ')}列 : `;
                                msg += msg_arr[i].toString() + " ";
                            }
                            errorMessageArr.push(msg_title + msg)
                        } else if (msg_arr.constructor.name.toLowerCase() === "string") {
                            errorMessageArr.push(msg += msg_arr);
                        } else {
                            errorMessageArr.push(msg += msg_arr.toString())
                        }
                    } else {
                        msg = errorArr[index]
                        errorMessageArr.push(msg)
                    }


                }
            }

            // 錯誤訊息obj 處理
            const errorObjKeys = Object.keys(errorObj)
            if (errorObjKeys.length > 0) {
                let msg = ''
                for (let key in errorObj) {
                    // 錯誤陣列中的訊息
                    let msg_arr = dialogInfo.data[key];
                    if (msg_arr !== undefined) {
                        if (msg_arr.constructor.name.toLowerCase() === "array") {
                            msg = ''
                            for (let i in msg_arr) {
                                msg += JSON.stringify(msg_arr[i]);
                            }
                            errorMessageArr.push(msg_title + msg)
                        } else if (msg_arr.constructor.name.toLowerCase() === "object") {
                            msg = ''
                            for (let i in msg_arr) {
                                msg_title = `第${(' [' + ((errorObjKeys.indexOf(key)) + 1) + '] ')}列 : `;
                                msg += JSON.stringify(msg_arr[i]) + " ";
                            }
                            errorMessageArr.push(msg_title + msg)
                        } else if (msg_arr.constructor.name.toLowerCase() === "string") {
                            if (msg_arr !== 'null') {
                                // msg += msg_arr //不要這段, 避免文字重複出現
                                errorMessageArr.push(msg_title + msg_arr)
                            }
                        } else {
                            msg = msg_arr.toString();
                            errorMessageArr.push(msg)
                        }
                    }
                }
            }
        }else{
            errorMessageArr = [dialogInfo.data]
        }
    }


    return <React.Fragment>
        {openDialog ?
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={props.maxWidth}
                    style={{ zIndex: 1500 }}
                    onClose={props.closeClick}
                    open={props.openDialog}
                    scroll="paper"
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description">
                    <DialogTitle id="scroll-dialog-title">{props.dialogInfo.message}</DialogTitle>
                    <DialogContent dividers={true}>
                        {errorMessageArr.length < 15 ?
                            errorMessageArr.map((item, index) => {
                                return <DialogContentText key={index}>{item}</DialogContentText>
                            })
                            :
                            <React.Fragment>
                                {errorMessageArr.slice(0, 14).map((item, index) => {
                                    return <DialogContentText key={index}>{item}</DialogContentText>
                                })}
                                <DialogContentText style={{ writingMode: "vertical-lr", padding: "10px" }}>...</DialogContentText>
                                <div style={{ width: "100%", padding: "10px 0", fontSize: "1rem" }}>
                                    已阻擋了 <span style={{ color: "#3f51b5", fontSize: "1rem" }}>{errorMessageArr.length - 15}</span>
                                    個類似的錯誤訊息，請檢查類似的欄位問題
                                </div>
                            </React.Fragment>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            if (props.closeClick) { props.closeClick() }
                        }} color={props.color}>
                            關閉
                        </Button>
                    </DialogActions>
                </Dialog>

            </React.Fragment>
            : ""
        }

    </React.Fragment>

}



type TransitionProps = {
    children?: React.ReactElement<any, any>;
    direction?: SlideProps['direction']; // 根據您的需要添加其他prop
};
/**
 * @description dialog 出場動畫
 */
const Transition = React.forwardRef(function Transition(props: TransitionProps, ref: React.Ref<any>) {
    return <Slide direction="up" ref={ref} {...props} />;
});

type ConfirmDialogTSProps = {
    modalOpen: boolean,
    modal: ConfirmDialogProps & {
        [key: string]: any
    } | null,
    closeClick: () => void,
    children?: React.ReactNode,
}

/**
 * @description 確認及編輯用視窗
 * @param {boolean} dividers 顯示頂部和底部分隔線
 * @param {string} id 視窗 id
 * @param {boolean} fullWidth 設置 false 為禁用 maxWidth
 * @param {obj} modal 決定確認及編輯用視窗內容 
 * ex:  modal: {
                id: "", modal id
                modaltitle: "", modal 標題
                messages: "", modal 內容
                modalPosition: "baseline", 是否要有底線
                size: "", modal 大小
                attribute: "", modal 自定義屬性
                modalAction: "", modal 預設的確認按鈕的點擊事件
            },
 * @param {component} modalBtnGroup 按鈕 沒給就使用預設的取消及確認按鈕
 * @param {component} field modal 內容
 */
export function ConfirmDialogTS(props: ConfirmDialogTSProps) {
    return (
        <React.Fragment>
            {props.modalOpen && props.modal ?
                <Dialog TransitionComponent={Transition} transitionDuration={300}
                    id={!props.modal.id ? "confirmModal" : props.modal.id}
                    fullWidth={true} maxWidth={!props.modal.size ? "md" : props.modal.size}
                    scroll={!props.modal ? undefined : props.modal.scroll} data-attribute={!props.modal ? '' : props.modal.attribute}
                    open={props.modalOpen} aria-labelledby="form-dialog-title">
                    <div style={{ display:"flex",justifyContent:"space-between" }}>
                        <DialogTitle>
                            {!props.modal ? '' : props.modal.modaltitle}
                        </DialogTitle>
                        <Button type="button" disableRipple={true} onClick={props.closeClick} style={{ background: "none", color: "#9fa2a5" }}>
                            <Close />
                        </Button>
                    </div>
                    <DialogContent style={{ overflow: "hidden", padding: props.modal?.padding }} dividers={true}>
                        {props.modal.messages}
                        {!!props.modal.field ? props.modal.field : ""}
                    </DialogContent>
                    <DialogActions>
                        {!props.modal.modalBtnGroup ?
                            <div style={{ width: "100%", display:"flex",justifyContent:"space-between" }}>
                                <Button color="primary" type="button" onClick={props.closeClick}>
                                    取消
                                </Button>
                                <Button className="MuiOtherButton" color="primary" type="button"
                                    onClick={() => {
                                        if (!!props.modal && props.modal.modalAction) {
                                            props.modal.modalAction()
                                        }
                                    }}>
                                    確認
                                </Button>
                            </div> :
                            props.modal.modalBtnGroup
                        }
                    </DialogActions>
                </Dialog>
                : null
            }
        </React.Fragment>
    );
}